module.exports = __webpack_public_path__ + "img/personPosition_uncheck.9aea2c78.png";